<template>

  <div class="forma-inner">

    <div class="container">

      <iframe src="https://leads.pingyo.co.uk/application/form/RISE-UK1/-/IFRAME1" height="3880" width="960" />

    </div>

  </div>

</template>

<script>

import vueSlider from 'vue-slider-component';
import axios from 'axios';

export default {
  name: 'formIf',
  components: {
    vueSlider,
  },
  data() {
    return {
      step: 1,
      stepsTotal: 4,
      isNextModalActive: false,
      isCardModalActive: false,
      result: false,
      sliders: {
        moneySlider: {
          value: 400,
          min: 100,
          max: 3500,
          interval: 50,
          tooltip: false,
          dotSize: 32,
          processStyle: {
            backgroundColor: '#99d55a',
          },
          bgStyle: {
            backgroundColor: '#eeeeee',
          },
        },
        monthsSlider: {
          value: 4,
          plural: true,
          min: 1,
          max: 24,
          tooltip: false,
          dotSize: 32,
          processStyle: {
            backgroundColor: '#99d55a',
          },
          bgStyle: {
            backgroundColor: '#eeeeee',
          },
        },
      },
      RequestJSON: {
        Campaign: 'TEST',
        AffiliateId: 'RISE-UK1',
        // Timeout: 100,
        // SubAffiliate: null,
        TestOnly: false,
        SourceDetails: {
          Address: undefined,
          ClientUserAgent: navigator.userAgent,
          CreationUrl: 'http://speedyloans.co.uk',
          ReferringUrl: 'http://speedyloans.co.uk',
        },
      },
      Application: {
        AddressCity: '',
        AddressCounty: '',
        AddressMoveIn: '',
        AddressPostcode: '',
        AddressStreet1: '',
        BankAccountNumber: '',
        BankCardType: undefined,
        UsesOnlineBanking: false,
        BankRoutingNumber: '',
        ConsentToCreditSearch: true,
        ConsentToMarketingEmails: false,
        ConsentToMarketingSms: false,
        ConsentToMarketingPhone: false,
        DateOfBirth: '',
        IncomePaymentType: undefined,
        Email: '',
        EmployerIndustry: undefined,
        // EmployerName: 'unemployed',
        EmployerName: '',
        EmploymentStarted: '',
        FirstName: '',
        HouseNumber: '',
        FollowingPayDate: '',
        HomePhoneNumber: '',
        HouseName: '',
        IncomeSource: undefined,
        JobTitle: '',
        LastName: '',
        LoanAmount: 400,
        MobilePhoneNumber: '',
        NextPayDate: '',
        PayAmount: undefined,
        PayFrequency: 0,
        ResidentialStatus: 0,
        Term: 3,
        Title: 0,
        WorkPhoneNumber: '',
        MonthlyMortgageRent: undefined,
        MonthlyCreditCommitments: undefined,
        OtherExpenses: undefined,
        Transport: undefined,
        Food: undefined,
        Utilities: undefined,
        ConfirmedByApplicant: true,
        MaritalStatus: 0,
        LoanProceedUse: 0,
        NumberOfDependents: undefined,
        CombinedMonthlyHouseholdIncome: 0,
        ApplicationExtensions: [],
      },
      applicationFields: {
        Title: {
          1: 'Mr',
          2: 'Mrs',
          3: 'Ms',
          4: 'Miss',
        },
        MaritalStatus: {
          1: 'Single',
          2: 'Married',
          3: 'LivingTogether',
          4: 'Separated',
          5: 'Divorced',
          6: 'Widowed',
          7: 'Other',
        },
        NumberOfDependents: {
          0: 'None',
          1: 1,
          2: 2,
          3: 3,
          4: 4,
          5: '5+',
        },
        AddressesAvailable: [],
        ManualAddress: false,
        IncomeSource: {
          1: 'Self Employed',
          2: 'Employed Full Time',
          3: 'Employed Part Time',
          4: 'Employed Temporary',
          5: 'Pension',
          6: 'Disability Benefits',
          7: 'Benefits',
        },
        EmployerIndustry: {
          1: 'Construction\\Manufacturing',
          2: 'Military',
          3: 'Health',
          4: 'Banking\\Insurance',
          5: 'Education',
          6: 'Civil Service',
          7: 'Supermarket\\Retail',
          8: 'Utilities\\Telecom',
          9: 'Hotel, Restaurant and Leisure',
          10: 'Other, Office-based',
          11: 'Other, not Office-based',
          12: 'None',
          13: 'Driving\\Delivery',
          14: 'Administration\\Secretarial',
          15: 'Mid Level Management',
          16: 'Senior Level Management',
          17: 'Skilled Trade',
          18: 'Professional',
        },
        timeAtAddressYears: undefined,
        timeAtAddressMonths: undefined,
        timeEmployedYears: undefined,
        timeEmployedMonths: undefined,
        workNumber: undefined,
        homeNumber: undefined,
        mobNumber: undefined,
        NextPay: undefined,
        FollowingPay: undefined,
      },
      errors: {
        // messages: {
        //   phoneError: 'Must be valid Number',
        // },
      },
      badDates: {
        dates: [
          // '2019-01-01',
          // 'April 19th, 2019',
          // 'April 22nd, 2019',
          // 'May 6th, 2019',
          // 'May 27th, 2019',
          // 'August 26th, 2019',
          // 'December 25th, 2019',
          // 'December 26th, 2019',
          // 'January 1st, 2020',
          // 'April 10th, 2020',
          // April 13th, 2020,
          // May 4th, 2020,
          // May 25th, 2020,
          // August 31st, 2020,
          // December 25th, 2020,
          // December 26th, 2020,
          // December 28th, 2020,
          // January 1st, 2019,
          // April 19th, 2019,
          // April 22nd, 2019,
          // May 6th, 2019,
          // May 27th, 2019,
          // August 26th, 2019,
          // December 25th, 2019,
          // December 26th, 2019,
          // January 1st, 2020,
          // April 10th, 2020,
          // April 13th, 2020,
          // May 4th, 2020,
          // May 25th, 2020,
          // August 31st, 2020,
          // December 25th, 2020,
          // December 26th, 2020,
          // December 28th, 2020
        ],
      },
      waiting: false,
      waitingText: '',
    };
  },
  watch: {
    step(val) {
      console.log(this.step);
      console.log(dataLayer);

      // window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        'event': 'formStep',
        'stepNo': val,
        'formId': 'form-1',
      });
    },
    payFreq(val) {
      // console.log('payFreq Changed! =====' + val);
      var d = new Date(); // date now
      var n = d.getMonth(); // month now
      var y = d.getFullYear(); // year now
      let payNext = false;
      if(val == 4 || val == 5) {
        console.log('Last Day of month');
        payNext = new Date(y, n + 1, 0); // get last day of month

        let i;
        for (i = 0; i < this.badDates.dates.length; i += 1) {
          // console.log(this.badDates.dates[i], '<bad', date);
          if (date === this.badDates.dates[i]) {
            // console.log('badDate!');
            console.log('Pay Date must not be on a bank Holiday');
          }
        }

        if(payNext == d) { //check if today => add 1month
          payNext.setMonth(payNext.getMonth() + 1);
        }
        if(payNext.getDay() == 0) {  // if sunday -2days
          payNext.setDate(payNext.getDate() - 2);
        }
        if(payNext.getDay() == 6) {  // if saturdat -1days
          payNext.setDate(payNext.getDate() - 1);
        }

      } else if(val == 9) {
        payNext = this.lastFridayOfMonth(y, n);

        if(payNext <= d) {
          payNext = this.lastFridayOfMonth(y, n+1);
        }
      } else if(val) {
        this.Application.NextPayDate = '';
        this.Application.FollowingPayDate = '';
        this.applicationFields.FollowingPay = undefined;
        this.applicationFields.NextPay = undefined;
      }

      if (payNext) {
        console.log('adiuhashduiasdiuasui');
        var dd = payNext.getDate();
        var mm = payNext.getMonth() + 1; //January is 0!

        var yyyy = payNext.getFullYear();
        if (dd < 10) {
          dd = '0' + dd;
        }
        if (mm < 10) {
          mm = '0' + mm;
        }
        var payNextFormatted = dd + '/' + mm + '/' + yyyy;
        var payNextFormatted2 = yyyy + '-' + mm + '-' + dd;

        this.applicationFields.NextPay = payNextFormatted2;

        this.nextPayDate(payNextFormatted2, 0);

      }
    }
  },
  computed: {
    progressBar() {
      return this.step / this.stepsTotal * 100;
    },
    payFreq() {
      return this.Application.PayFrequency;
    }
  },
  mounted() {
    // Add ApplicationExtensions from query string
    if (this.$route.query.gclid) {
      this.Application.ApplicationExtensions.push({ gclid: this.$route.query.gclid });
    }

    // Get user IP and store in SourceDetails
    axios.get('https://api.ipify.org')
      .then((response) => {
        console.log(response.data);
        this.RequestJSON.SourceDetails.Address = response.data;
      })
      .catch((error) => {
        console.log(error.response);
      });

    this.RequestJSON.Application = this.Application;
  },
  created() {
    dataLayer.push({
      'event': 'formStep',
      'stepNo': 1,
      'formId': 'form-1',
    });
  },
  methods: {
    lastFridayOfMonth(year, month) { "use strict";
    	var lastDay = new Date(year, month+1, 0);
    	if(lastDay.getDay() < 5) {
    		lastDay.setDate(lastDay.getDate() - 7);
    	}
    	lastDay.setDate(lastDay.getDate() - (lastDay.getDay() -5));
    	return lastDay;
    },
    prev() {
      this.step--;
    },
    next() {
      this.step++;
    },
    addressLookup(postcode, event) {
      if (event) event.preventDefault();
      axios.get(`https://api.getAddress.io/find/${postcode}?api-key=XFvWQjqVKEa_Rr-zbh4VGA17329&expand=true`)
        .then((response) => {
          this.applicationFields.AddressesAvailable = response.data.addresses;
          this.applicationFields.ManualAddress = true;
        })
        .catch((error) => {
          console.log(error.response);
          this.applicationFields.ManualAddress = 'error';
        });
    },
    chooseAddress(addressId) {
      // console.log(this.applicationFields.AddressesAvailable[addressId]);
      this.Application.HouseNumber = this.applicationFields.AddressesAvailable[addressId].building_number;
      this.Application.AddressStreet1 = this.applicationFields.AddressesAvailable[addressId].thoroughfare;
      this.Application.AddressCity = this.applicationFields.AddressesAvailable[addressId].town_or_city;
      this.Application.AddressCounty = this.applicationFields.AddressesAvailable[addressId].county;

      if (!this.Application.AddressCounty && this.Application.AddressCity === 'London') {
        this.Application.AddressCounty = 'Greater London';
      }
      // console.log(this.Application.HouseNumber);
    },
    timestampFromToday(years = 0, months = 0) {
      let timestamp = Math.round(new Date().getTime() / 1000); // getTimestamp of today in Milliseconds
      timestamp -= (years * 31536000) + (months * 2628003.6); // timestamp = years* how many hours in year + hours in month
      let newTime = new Date(timestamp * 1000); // convert back to timestamp
      newTime = (Date.parse(newTime) / 1000);
      return newTime * 1000;
    },
    employedTime(years = 0, months = 0) {
      // eslint-disable-next-line
      this.Application.EmploymentStarted = `\/Date(${this.timestampFromToday(years, months)})\/`;
    },
    addressTime(years = 0, months = 0) {
      // eslint-disable-next-line
      this.Application.AddressMoveIn = `\/Date(${this.timestampFromToday(years, months)})\/`;
    },
    dateOfBirtConvert(dateString) {
      let dateStamp = new Date(dateString).getTime() / 1000;
      dateStamp *= 1000;
      let eighteenYearsAgo = new Date();
      eighteenYearsAgo = eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 18);
      console.log(`japa: ${eighteenYearsAgo}`);
      // day18YearsAgo.setMonth(day18YearsAgo.getMonth() – 12);
      // eighteenYearsAgo = eighteenYearsAgo.getTime() / 1000;
      console.log(dateStamp, eighteenYearsAgo);
      if (dateStamp < eighteenYearsAgo) { // check if age > 18
        // eslint-disable-next-line
        this.Application.DateOfBirth = `\/Date(${dateStamp})\/`;
      } else {
        console.log('Not old enough');
        // const dobError = "You must be at least 18+";
      }
    },
    // phoneConvert(num = 0, type) {
    //   if (num.length !== 10 && num.length !== 11) {
    //     // const numError = "<span> Number must be 10-11 Digits</span>";
    //     console.log('NumError', num.length);
    //     this.errors[`${type}Number`] = 'Must be valid Number';
    //   } else if (type) {
    //     this.errors[`${type}Number`] = '';
    //     const name = `${type}Number`;
    //     this.Application[name] = num;
    //     console.log(name, num.length);
    //   } else {
    //     this.Application.type = num;
    //   }
    // },
    nextPayDate(date, following = 0) {
      const todayDate = new Date().getTime() / 1000;
      let payDate = new Date(date).getTime() / 1000;
      const payDateSave = new Date(date);
      const monthToday = payDateSave.getMonth() + 1;

      let fourtyFourFrom = new Date().getTime();
      if (following < 1) {
      } else {
        fourtyFourFrom = new Date(this.applicationFields.NextPay);
      }

      let payDatePlusWeek = new Date(date);
      payDatePlusWeek.setDate(payDatePlusWeek.getDate() + 7);

      let payDatePlusHalfWeek = new Date(date);
      payDatePlusHalfWeek.setDate(payDatePlusHalfWeek.getDate() + 4);

      let payDatePlusTwoWeeks = new Date(date);
      payDatePlusTwoWeeks.setDate(payDatePlusTwoWeeks.getDate() + 14);

      let payDatePlusFourWeeks = new Date(date);
      payDatePlusFourWeeks.setDate(payDatePlusFourWeeks.getDate() + 28);

      let payDatePlusOneMonth = new Date(date);
      payDatePlusOneMonth.setMonth(payDatePlusOneMonth.getMonth() + 1);

      let todayPlusFourtyFour = new Date(fourtyFourFrom);
      todayPlusFourtyFour.setDate(todayPlusFourtyFour.getDate() + 45);

      if (payDate > todayDate) {
        this.errors.nextPayErr = '';
        this.errors.followingPayErr = '';
        // console.log('in Future', todayDate, payDate);
        let i;
        for (i = 0; i < this.badDates.dates.length; i += 1) {
          // console.log(this.badDates.dates[i], '<bad', date);
          if (date === this.badDates.dates[i]) {
            // console.log('badDate!');
            this.errors.nextPayErr = 'Pay Date must not be on a bank Holiday';
          }
        }

        console.log('odayPlusFourtyFour.getTime() / 1000 --- '+(todayPlusFourtyFour.getTime() / 1000));
        console.log('payDate --- '+payDate);
        // if ( (todayPlusFourtyFour.getTime() / 1000) > payDate) {
        if ( true ) {

        // if (payDate - 3888000 < todayDate) {
          this.errors.nextPayErr = '';
          this.errors.followingPayErr = '';
          // console.log('success');
          payDate *= 1000;
          if (following < 1) {
            // console.log('NextSuccess!');
            // eslint-disable-next-line
            this.Application.NextPayDate = `\/Date(${payDate})\/`;

            let followingSet = false;
            let payFollowing = false;
            if(this.Application.PayFrequency == 4 || this.Application.PayFrequency == 5 || this.Application.PayFrequency == 6) {
              if(this.Application.PayFrequency == 6) {
                payFollowing = payDateSave;
                payFollowing.setMonth(payFollowing.getMonth() + 1);
              } else {
                var aan = payDateSave.getMonth(); // month now
                var aay = payDateSave.getFullYear(); // year now
                payFollowing = new Date(aay, aan + 2, 0); // get last day of month
              }
              if(payFollowing.getDay() == 0) {  // if sunday -2days
                payFollowing.setDate(payFollowing.getDate() - 2);
              }
              if(payFollowing.getDay() == 6) {  // if saturdat -1days
                payFollowing.setDate(payFollowing.getDate() - 1);
              }
            } else if (this.Application.PayFrequency == 9) {
              payFollowing = this.lastFridayOfMonth(payDateSave.getFullYear(), payDateSave.getMonth()+1);
            } else if(this.Application.PayFrequency == 1) {
              payFollowing = payDateSave;
              payFollowing.setDate(payFollowing.getDate() + 7);
            } else if(this.Application.PayFrequency == 2) {
              payFollowing = payDateSave;
              payFollowing.setDate(payFollowing.getDate() + 3);

              if(payFollowing.getDay() == 0) {  // if sunday -2days
                payFollowing.setDate(payFollowing.getDate() + 1);
              }
              if(payFollowing.getDay() == 6) {  // if saturdat -1days
                payFollowing.setDate(payFollowing.getDate() - 1);
              }

            } else if(this.Application.PayFrequency == 3 || this.Application.PayFrequency == 7) {
              payFollowing = payDateSave;
              payFollowing.setDate(payFollowing.getDate() + 14);
            } else if(this.Application.PayFrequency == 8) {
              payFollowing = payDateSave;
              payFollowing.setDate(payFollowing.getDate() + 28);
            }
            if(payFollowing) {

              var dd = payFollowing.getDate();
              var mm = payFollowing.getMonth() + 1; //January is 0!

              var yyyy = payFollowing.getFullYear();
              if (dd < 10) {
                dd = '0' + dd;
              }
              if (mm < 10) {
                mm = '0' + mm;
              }
              var payNextFormatted2 = yyyy + '-' + mm + '-' + dd;

              this.applicationFields.FollowingPay = payNextFormatted2;

              this.nextPayDate(payNextFormatted2, 1);

            }
          } else {
            // console.log('FollowSuccess!');
            // eslint-disable-next-line
            this.Application.FollowingPayDate = `\/Date(${payDate})\/`;
          }
        } else if (following < 1) {
          console.log(following);
          this.errors.followingPayErr = 'must be less than 45 days in the future';
        } else {
          this.errors.nextPayErr = 'must be less than 45 days in the future';
        }
      } else if (following < 1) {
        this.errors.followingPayErr = 'must be in the future';
      } else {
        this.errors.nextPayErr = 'must be in the future';
      }
    },
    applyForLoan() {
      // console.log(this.Application);
      this.result = this.Application;
      // this.result.HomePhoneNumber = this.Application.MobilePhoneNumber;
      this.Application.BankRoutingNumber = this.applicationFields.BankRoutingNumber;

      this.waiting = true;
      this.waitingText = 'Sending...';

      // send POST date
      const axiosConfig = {
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          // 'App-Test-Response-Type': 'LenderMatchFound',
        },
      };

      axios.post('https://leads.pingyo.co.uk/application/submit', JSON.stringify(this.RequestJSON), axiosConfig)
        .then((response) => {
          // console.log(response);
          this.waitingText = 'Sent! Waiting for response...';
          if (response.status === 202) {
            setTimeout(() => {
              const correlationId = response.data.CorrelationId;
              this.checkApplicationProgress(correlationId);
            }, 5000);
          }
        })
        .catch((error) => {
          console.log(error.response);
          this.loanResultFail();
        });
    },
    checkApplicationProgress(correlationId) {
      axios.get(`https://leads.pingyo.co.uk/application/status/${correlationId}`)
        .then((response) => {
          let progress = response.data.PercentageComplete;
          if (progress !== 100) {
            setTimeout(() => {
              this.checkApplicationProgress(correlationId);
            }, 3000);
          } else if (progress === 100) {
            this.loanResult(response);
          }
        })
        .catch((error) => {
          console.log(error.response);
          this.loanResultFail();
        });
    },
    loanResult(responseData) {
      const redirection = responseData.data.RedirectionUrl;
      if (!redirection) {
        this.loanResultFail();
      } else {
        this.loanResultSuccess(redirection);
      }
    },
    loanResultFail() {
      this.waiting = false;
      this.isCardModalActive = false;
      this.isNextModalActive = false;
      this.$swal({
        type: 'error',
        title: 'Oops...',
        text: 'No matching lenders found.',
      });
    },
    loanResultSuccess(redirectionUrl) {
      this.waiting = false;
      this.isCardModalActive = false;
      this.isNextModalActive = false;
      this.$swal({
        type: 'success',
        title: 'Success!',
        text: 'You will be redirected in 5 seconds. Click below if you don\'t want to wait',
        confirmButtonText: 'Go now!',
      }).then((result) => {
        if (result.value) {
          window.location = redirectionUrl;
        }
      });
      setTimeout(() => {
        window.location = redirectionUrl;
      }, 5000);
    },
    loadTestData() {
      this.RequestJSON.Application.AddressCity = 'London';
      this.RequestJSON.Application.AddressCounty = 'Greater London';
      // eslint-disable-next-line
      this.RequestJSON.Application.AddressMoveIn = '\/Date(1392204322000)\/';
      this.RequestJSON.Application.AddressPostcode = 'SE14 5AD';
      this.RequestJSON.Application.AddressStreet1 = 'New Cross Road';
      this.RequestJSON.Application.BankAccountNumber = '12312312';
      this.RequestJSON.Application.BankCardType = 4;
      this.RequestJSON.Application.UsesOnlineBanking = true;
      this.RequestJSON.Application.BankRoutingNumber = '121212';
      this.RequestJSON.Application.ConsentToCreditSearch = true;
      this.RequestJSON.Application.ConsentToMarketingEmails = true;
      this.RequestJSON.Application.ConsentToMarketingSms = true;
      this.RequestJSON.Application.ConsentToMarketingPhone = true;
      // eslint-disable-next-line
      this.RequestJSON.Application.DateOfBirth = '\/Date(662688000000)\/';
      this.RequestJSON.Application.IncomePaymentType = 4;
      this.RequestJSON.Application.Email = 'mariusz@example.com';
      this.RequestJSON.Application.EmployerIndustry = 2;
      this.RequestJSON.Application.EmployerName = 'Alphabet inc';
      // eslint-disable-next-line
      this.RequestJSON.Application.EmploymentStarted = '\/Date(1423740346000)\/';
      this.RequestJSON.Application.FirstName = 'Mariusz';
      this.RequestJSON.Application.HouseNumber = '192e';
      // eslint-disable-next-line
      this.RequestJSON.Application.FollowingPayDate = '\/Date(1550793600000)\/';
      this.RequestJSON.Application.HomePhoneNumber = '01123456789';
      this.RequestJSON.Application.HouseName = 'Test';
      this.RequestJSON.Application.IncomeSource = 2;
      this.RequestJSON.Application.JobTitle = '';
      this.RequestJSON.Application.LastName = 'Test Last Name';
      this.RequestJSON.Application.LoanAmount = 400;
      this.RequestJSON.Application.MobilePhoneNumber = '07123456789';
      // eslint-disable-next-line
      this.RequestJSON.Application.NextPayDate = '\/Date(1550793600000)\/';
      this.RequestJSON.Application.PayAmount = 5000;
      this.RequestJSON.Application.PayFrequency = 9;
      this.RequestJSON.Application.ResidentialStatus = 1;
      this.RequestJSON.Application.Term = 3;
      this.RequestJSON.Application.Title = '1';
      this.RequestJSON.Application.WorkPhoneNumber = '02123456789';
      this.RequestJSON.Application.MonthlyMortgageRent = 750;
      this.RequestJSON.Application.MonthlyCreditCommitments = 0;
      this.RequestJSON.Application.OtherExpenses = 75;
      this.RequestJSON.Application.Transport = 125;
      this.RequestJSON.Application.Food = 225;
      this.RequestJSON.Application.Utilities = 75;
      this.RequestJSON.Application.ConfirmedByApplicant = true;
      this.RequestJSON.Application.MaritalStatus = 1;
      this.RequestJSON.Application.LoanProceedUse = 5;
      this.RequestJSON.Application.NumberOfDependents = 0;
    },
  },
};
// Function for converting Date to string const dateString = date.replace('-', '');
// const year = dateString.substring(0, 4);
// const month = dateString.substring(4, 6);
// const day = dateString.substring(6, 8);
// const newDate = new Date(year, month - 1, day);
</script>


<style lang="scss">

// .carda {
//   height: 0;
// }



.bounce-enter-active {
  animation: bounce-in .15s;
  animation-delay: .1s;
  opacity: 0;
  height: auto;
}
.bounce-leave-active {
  animation: bounce-in .15s reverse;
  margin-bottom: 200px;
}
@keyframes bounce-in {
  0% {
    transform: scale(0.9);
    opacity: 0;
  }
  50% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.forma {
  padding: 5rem 0 3rem;
  text-align: center;
  // min-height: calc(100vh - 3.25rem);
  min-height: 535px;
  display: flex;
  align-items: center;
  justify-content: center;

  .label {
    text-align: center;
  }
}
.carda {
  width: 700px;
  margin: auto;
  max-width: calc(100% - 4rem);
}

.button {
  font-weight: 800;
}

.step-buttons-c .is-primary,
.step-buttons-c .is-success {
  margin-left: auto;
}
.step-buttons-c {
  display: flex;
  padding: 0 1.2rem;
  margin-top: 3rem;
  align-items: center;
}

.field.radio-btn.has-addons {
  justify-content: center;
}


.input, .taginput .taginput-container.is-focusable, .textarea, .select select {
  font-weight: 800;
  font-size: 1rem;
  background: #efefef;
  border: 2px solid #74ba6c;
  -webkit-box-shadow: 0px 0px 20px rgba(116, 186, 108, 0.33);
  box-shadow: 0px 0px 20px rgba(116, 186, 108, 0.33);
  border-radius: 6px;
}


iframe {
  max-width: 100%;
}

.carda--8 {
  .field.radio-btn.radio-btn--blocks {
    flex-wrap: wrap;
  }
  .field.radio-btn.radio-btn--blocks .control {
    flex-basis: 50%;
    max-width: calc(50% - 0.8rem);
    margin-bottom: 0.4rem;
    margin: 0.4rem;
  }
  .field.radio-btn.radio-btn--blocks .control:nth-child(3) {
    flex-basis: 100%;
    max-width: calc(100% - 1px);
  }
  .field.radio-btn.radio-btn--blocks .control .b-radio {
    width: 100%;
    border-radius: 4px !important;
  }
}

.carda--10 {
  .has-addons button.button.is-primary {
    width: auto !important;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    font-size: 0.8rem;
    height: 36px;
  }
}

.field.has-addons {
  position: relative;

  p.help.is-danger {
    position: absolute;
    top: 105%;
  }
}



.radio-btn--blocks.is-grouped.is-grouped-multiline {
  flex-wrap: wrap;
}
.field.is-grouped.is-grouped-multiline > .control {
  flex-basis: calc(50% - 0.75rem);
}
.field.is-grouped.is-grouped-multiline > .control .b-radio {
  width: 100%;
}

.carda--11 {
  .field.is-grouped.is-grouped-multiline > .control {
    max-width: calc(50% - 0.75rem);
  }
  label.b-radio.radio.button.is-large {
    height: 3em;
    white-space: normal;
  }
}

.carda.carda--23 {
  margin-top: -2rem;
}

.small {
  font-size: 0.65rem;
}

// .step-buttons-c {
//   position: fixed;
//   right: 0;
//   left: 0;
//   bottom: 0;
//   padding: 0.4rem;
//   border-top: 1px solid #acddb0;
//   align-items: center;
//   justify-content: space-between;
//   background: #fff;
//   z-index: 1;
// }

@media (max-width: 768px) {
  .forma {
    display: block;
    min-height: 410px;
  }
}
</style>
